import { loadView } from '@/router'

export default [
  {
    path: 'enquiries',
    name: 'customerservice-enquiries',
    component: loadView('Application/CustomerService/Enquiries')
  }
]
